import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Form, PagedResult } from 'app/core/interfaces';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { QuerifyService } from '../services/querify.service';
import { Queries } from './graphql/queries';

@Injectable({
  providedIn: 'root'
})
export class FormsApi {
  constructor(
    private apollo: Apollo,
    private queries: Queries,
    private querify: QuerifyService
  ) { }

  search(query?, options?): Observable<PagedResult> {
    options = this.querify.transformOptions(query, options);
    return this.apollo
      .query({
        query: this.queries.formsPaginated(),
        variables: options
      })
      .pipe(
        map(({ data }) => {
          return data['forms'];
        })
      );
  }

  searchOne(formsId): Observable<Form> {
    return this.apollo
      .query({
        query: this.queries.searchForm(),
        variables: { id: formsId }
      })
      .pipe(
        map(({ data }) => {
          return data['form'];
        })
      );
  }
}
